'use client'
import React, { useState } from 'react'

import data from '../../../data/innerpages/portfolio/portfolio-gallery'

const ITEMS_PER_PAGE = 6

function GalleryGrid() {
  const [activeFilter, setActiveFilter] = useState('All')
  const [currentPage, setCurrentPage] = useState(1)

  const filteredData =
    activeFilter === 'All'
      ? data
      : data.filter((item) => item.subTitle.toLowerCase() === activeFilter.toLowerCase())

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE)

  const paginatedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  )


  const handleFilterClick = (filter) => {
    setActiveFilter(filter)
    setCurrentPage(1) // Reset to first page on filter change
  }

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return
    setCurrentPage(page)
  }

  return (
    <section className="tc-latest-gallery-style1">
      <div className="container">
        <div className="content">
          <div className="gallery">
            <div className="filter mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="links">
                {['All', 'rings', 'necklaces', 'bracelets', 'earrings'].map((filter) => (
                  <a
                    key={filter}
                    href="#0"
                    onClick={(e) => {
                      e.preventDefault();
                      handleFilterClick(filter);
                    }}
                    className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                  >
                    {filter.charAt(0).toUpperCase() + filter.slice(1)}
                  </a>
                ))}
              </div>
            </div>

            <div className="gallery-content wow fadeInUp slow" data-wow-delay="0.4s">
              <div className="row">
                {paginatedData.map((item, i) => (
                  <div key={i} className="col-lg-4 mb-4">
                    <div className="gallery-card">
                      <a href={item.img} className="img" data-fancybox="gallery">
                        <img src={item.img} alt={item.title} className="img-cover" />
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              <nav aria-label="Page navigation">
                <ul className="pagination justify-content-center mt-4">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <a
                      className="page-link"
                      href="#0"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      <i className="fal fa-chevron-left"></i>
                    </a>
                  </li>
                  {Array.from({ length: totalPages }, (_, idx) => (
                    <li
                      key={idx}
                      className={`page-item ${currentPage === idx + 1 ? 'active' : ''}`}
                    >
                      <a className="page-link" href="#0" onClick={() => handlePageChange(idx + 1)}>
                        {idx + 1}
                      </a>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <a
                      className="page-link"
                      href="#0"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      <i className="fal fa-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GalleryGrid